import React, { forwardRef } from 'react';
import MuiBox from '@mui/material/Box';
const BoxWithRef = ({ component, children, _sx, className = '', onClick, id, dataTestId, }, ref) => (React.createElement(MuiBox, { component: component, id: id, sx: _sx, className: className, onClick: onClick, ref: ref, "data-testid": dataTestId }, children));
export const Box = forwardRef(BoxWithRef);
